import { useState, useEffect } from 'react';

export function usePlayersFilter(analysis) {
  const [active, setActivePlayers] = useState({});
  const [all, setAllPlayers] = useState([]);

  // set the player list the first time the analysis is loaded
  useEffect(() => {
    if (all.length === 0 && analysis) {
      setAllPlayers(getPlayersFromAnalysis(analysis));
    }
  }, [all, analysis]);

  const onChange = (playerId, value) => {
    setActivePlayers({ ...active, [playerId]: value });
  };

  return { active, all, onChange };
}

function getPlayersFromAnalysis({ lineups }) {
  if (!lineups) return [];

  const byId = {};
  lineups.forEach(lineup => {
    lineup.lineup.players.forEach(player => {
      byId[player.id] = player;
    });
  });

  const players = Object.keys(byId)
    .map(id => byId[id])
    .sort((a, b) => a.jersey - b.jersey);
  return players;
}
